import React from 'react';

const Settings = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Settings</h1>
      <div className="bg-white rounded-lg shadow-md p-6">
        <p className="text-gray-600">Settings coming soon...</p>
      </div>
    </div>
  );
};

export default Settings;
